

















































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppRatingBar from '@/components/AppRatingBar.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import { CURRENT_USER } from '@/gql/auth'
import { MY_USER } from '@/gql/user'
import { Item } from '@/mixins'

@Component({
  components: {
    AppRatingBar,
    AppRouterLink
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    }
  }
})
export default class extends Mixins(Item) {
  @Prop(Boolean) readonly form!: boolean
  @Prop(String) readonly fromFeedId: string | undefined
  @Prop(Object) readonly feedItem!: { item: {
    id: string;
    price: number;
    orgPrice: number;
    isLiked: boolean;
    isActive: boolean;
    display: boolean;
    medias: { path: string }[];
    seller: { shop: { status: string } };
  }; }

  currentUser: { id: string } | null = null
  myUser = {}

  get item () {
    return this.feedItem.item
  }

  get isPurchasable () {
    return this.item.isActive && this.item.display && this.item.seller.shop.status === 'ACTIVE'
  }

  async onClickDisabled () {
    if (!this.form) await this.showToast('판매종료된 아이템입니다')
  }

  get discountRate () {
    if (!this.item.orgPrice) return undefined
    return Math.round((this.item.orgPrice - this.item.price) * 100 / this.item.orgPrice)
  }

  async onClickLikeItem () {
    await this.toggleLikeItem(this.item.id, this.item.isLiked)
  }
}
